module.exports = __webpack_public_path__ + "img/logo1 (47).f941eb92.jpg";